import post from './post.js'	

export default {	
  post	
}